import React from 'react';
import { Modal } from 'react-bootstrap';

import api from '../../apiClient/v1';
import * as css from './TablaAuditoriaSemanal.css'

class ReporteRuta extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            data: {},
            estado: 0
        }
        this.show = () => this.setState({ visible: true })
        this.hide = () => this.setState({ visible: false })
    }

    componentDidMount() {
        api.auditoria.getRutaInicioAuditores(this.props.fechaInicio.format('YYYY-MM-DD'))
            .then((response) => {
                this.setState({
                    data: response.auditores,
                    estado: response.estado
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    componentDidUpdate(prevProps) {
        if (this.props.fechaInicio.format('YYYY-MM-DD') !== prevProps.fechaInicio.format('YYYY-MM-DD')) {
            api.auditoria.getRutaInicioAuditores(this.props.fechaInicio.format('YYYY-MM-DD'))
                .then((response) => {
                    this.setState({
                        data: response.auditores,
                        estado: response.estado
                    })
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    render() {
        const color = this.state.estado == 2 ? "btn btn-success btn-xs" : (this.state.estado == 1 ? "btn btn-warning btn-xs" : "btn btn-danger btn-xs") 
        return (
            <div>
                <button className={color} onClick={this.show} style={{ margin: '15px', alignSelf: 'center' }}>Reporte Ruta</button>
                <Modal show={this.state.visible} onHide={this.hide} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                <span>Reporte Inicio de Ruta Auditores, día {this.props.fechaInicio.format('dddd DD MMMM YYYY')}</span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Auditor</th>
                                    <th>Estado</th>
                                    <th>Hora Inicio</th>
                                    <th>Locales Pendientes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(this.state.data).map(([auditor, info]) => (
                                    <tr key={auditor}>
                                        <td style={{ alignContent: 'center' }}>{auditor}</td>
                                        <td style={{ alignContent: 'center' }}>{info.estado}</td>
                                        <td style={{ alignContent: 'center' }}>{info.muestras[0] ? info.muestras[0].ird : null}</td>
                                        <td>
                                            {info.pendientes.map((dato, index) => {
                                                return (
                                                    <p key={index} style={{ fontSize: '12px' }}>{dato.cliente} - {dato.ceco} - {dato.local}</p>
                                                )
                                            })}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Modal.Body >
                </Modal >
            </div >
        );
    }
}

export default ReporteRuta;


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/ReporteRuta.jsx